import React, { useEffect, useState } from 'react';
import { DEMOLINK, API_BASE_URL } from '../config';

const cardColors = [
  'linear-gradient(135deg, #eef3f0a6 0%, #f6fcf9 100%)', // green
  'linear-gradient(135deg, #667eeacb 0%, #2e46d1a8 100%)', // blue
  'linear-gradient(135deg, #232526b2 0%, #414345ab 100%)', // black/grey
  'linear-gradient(135deg, #bdc3c7b4 0%, #2c3e50a9 100%)', // grey/blue
  'linear-gradient(135deg, #043cf5b4 0%, #4464bea9 100%)', // grey/blue
  'linear-gradient(135deg, #f05858b4 0%, #f09d9da9 100%)', // grey/blue
];

function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', mobileNumber: '', message: '' });
  const [formStatus, setFormStatus] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/products.php`);
        const text = await res.text();
        const data = text ? JSON.parse(text) : null;

        if (!res.ok || !data || !data.success) {
          let msg = data?.message || data?.msg;

          if (!msg && !text) {
            msg = `Products API returned an empty response (HTTP ${res.status}).`;
          }

          if (!msg) {
            msg = `Unable to load products right now (HTTP ${res.status}).`;
          }

          setLoadError(msg);
          return;
        }

        setProducts(Array.isArray(data.products) ? data.products : []);
      } catch (error) {
        setLoadError('Unable to load products right now. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const openModal = (product) => {
    setModalProduct(product);
    setShowModal(true);
    setForm({ name: '', email: '', mobileNumber: '', message: '' });
    setFormStatus('');
  };
  const closeModal = () => {
    setShowModal(false);
    setModalProduct(null);
  };
  const handleFormChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleFormSubmit = async e => {
    e.preventDefault();
    setFormStatus('Sending...');
    try {
      const res = await fetch(`${API_BASE_URL}/interestedPerson.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          product: modalProduct?.pn || '',
          productId: modalProduct?.pid || ''
        })
      });

      const text = await res.text();
      const data = text ? JSON.parse(text) : null;

      if (!res.ok || !data) {
        setFormStatus('Error: Unable to submit right now.');
        return;
      }

      if (data.success) {
        setFormStatus('Thank you! We will contact you soon.');
        setTimeout(() => {
          setShowModal(false);
          setModalProduct(null);
          setForm({ name: '', email: '', mobileNumber: '', message: '' });
          setFormStatus('');
        }, 1200);
      } else {
        setFormStatus('Error: ' + (data.msg || 'Could not submit.'));
      }
    } catch (err) {
      setFormStatus('Error: Could not connect right now.');
    }
  };

  return (
    <div className="container py-0 products-container">
      {loading ? (
        <div className="text-center" style={{padding: '3rem'}}>
          <div className="spinner-border" role="status" style={{color: '#2563eb'}}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p style={{marginTop: '1rem', color: '#1f2937'}}>Loading our amazing services...</p>
        </div>
      ) : loadError ? (
        <div className="alert alert-danger text-center">{loadError}</div>
      ) : (
        <>
          <div className="row g-4 justify-content-center">
            {products.map((p, idx) => (
              <div className="col-md-6 col-lg-4" key={p.pid}>
                <div className="card" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                  <div className="card-body" style={{flex: 1}}>
                    <h5 className="card-title">{p.pn}</h5>
                    <div style={{ height: '180px', overflowY: 'auto', marginBottom: '1rem', paddingRight: '0.5rem' }}>
                      <p className="card-text">{p.product_detail}</p>
                    </div>
                  </div>
                  <div className="card-footer d-flex justify-content-between align-items-center gap-2" style={{flexWrap: 'wrap'}}>
                    <button
                      className="btn btn-outline-primary"
                      style={{flex: 1, minWidth: '120px'}}
                      onClick={() => openModal(p)}
                    >
                      <span className="me-2">📧</span>Get Interested
                    </button>
                    <a
                      href={`${DEMOLINK}${p.pmodel}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                      style={{flex: 1, minWidth: '100px'}}
                    >
                      <span className="me-2">🔗</span>View Demo
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="my-5 text-center" style={{padding: '3rem', background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(3, 105, 161, 0.05) 100%)', borderRadius: '12px', borderLeft: '4px solid #2563eb'}}>
            <h3 style={{color: '#1e3a8a', fontSize: '1.4rem', marginBottom: '1rem', fontWeight: 700}}>Why Choose NeeBun?</h3>
            <div style={{color: '#1f2937', fontSize: '1rem', lineHeight: 1.8}}>
              <p><strong>✨ Transforming ideas into digital reality</strong> with expert web and mobile app development.</p>
              <p><strong>🔒 Trusted by businesses</strong> for reliability, creativity, and end-to-end technology solutions.</p>
              <p><strong>🚀 Let's build your next big thing</strong> — faster, smarter, and beautifully designed.</p>
            </div>
          </div>
        </>
      )}

      {/* Professional Blue Modal */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(27, 26, 26, 0.8)' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Express Your Interest in {modalProduct?.pn}</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <p style={{color: '#1f2937', marginBottom: '1.5rem'}}>
                  Fill out the form below and our team will contact you shortly with more details about this service.
                </p>
                <form onSubmit={handleFormSubmit}>
                  <div className="form-group">
                    <label>Your Name</label>
                    <input type="text" className="form-control" name="name" value={form.name} onChange={handleFormChange} required placeholder="Mr. Ram Chandra Lohia" />
                  </div>
                  <div className="form-group">
                    <label>Your Email</label>
                    <input type="email" className="form-control" name="email" value={form.email} onChange={handleFormChange} required placeholder="you@example.com" />
                  </div>
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <input type="tel" className="form-control" name="mobileNumber" value={form.mobileNumber} onChange={handleFormChange} required pattern="[0-9]{10}" minLength="10" maxLength="10" placeholder="9999999999" />
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <textarea className="form-control" name="message" rows="4" value={form.message} onChange={handleFormChange} required placeholder="Tell us about your project..." />
                  </div>
                  <button type="submit" className="btn btn-primary w-100 py-2">
                    {formStatus && formStatus.includes('Sending') ? 'Sending...' : 'Send Message'}
                  </button>
                  {formStatus && (
                    <div className={`mt-3 alert ${formStatus.includes('Thank you') ? 'alert-success' : formStatus.includes('Error') ? 'alert-danger' : 'alert-info'} py-2 text-center`}>
                      {formStatus}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Products;
